module.exports = __webpack_public_path__ + "static/media/q-bg.d5cc0412.jpg";